<template>
<v-dialog>
    <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" v-bind="attrs" v-on="on">
            <v-icon small>mdi-plus</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newExercises || "New Exercise" }}</span>
        </v-btn>
    </template>
    <template v-slot:default="newExercise">
        <v-card>
            <v-toolbar elevation="0">
                <v-toolbar-title>New Exercise</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="newExercise.value = false"> 
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
               <v-container>
                   <v-row>
                       <v-col cols="12">
                            <label class="custom-label">{{ $page.props.lang.name || 'Name' }}</label>
                            <v-text-field v-model="exercise.name" 
                                :error-messages="responseErrors.name" 
                                :hide-details="!responseErrors.name"
                                @focus="responseErrors.name=''" 
                                outlined dense solo flat></v-text-field>
                        </v-col>
                   </v-row>
                   <v-row>
                       <v-col cols="12">
                            <label class="custom-label">{{ $page.props.lang.description || 'Description' }}</label>
                            <v-textarea v-model="exercise.description" 
                                :error-messages="responseErrors.description" 
                                :hide-details="!responseErrors.description"
                                @focus="responseErrors.description=''" 
                                outlined dense solo flat></v-textarea>
                        </v-col>
                   </v-row>
                   <v-row>
                       <v-col cols="12">
                            <label class="custom-label">{{ $page.props.lang.videoUrl || 'Video URL' }}</label>
                            <v-text-field v-model="exercise.url" 
                                :error-messages="responseErrors.url" 
                                :hide-details="!responseErrors.url"
                                @focus="responseErrors.url=''" 
                                outlined dense solo flat></v-text-field>
                        </v-col>
                   </v-row>
                   <v-row>
                        <v-col cols="12">
                            <label class="custom-label">{{ $page.props.lang.type || 'Type' }}</label>
                            <v-radio-group v-model="exercise.type" row>
                                <v-radio
                                    label="Just Reps"
                                    value="1"
                                ></v-radio>
                                <v-radio
                                    label="Weight &amp; Reps"
                                    value="2"
                                ></v-radio>
                                <v-radio
                                    label="Time"
                                    value="3"
                                ></v-radio>
                                <v-radio
                                    label="Time/Discance"
                                    value="4"
                                ></v-radio>
                                <v-radio
                                    label="Display Only"
                                    value="5"
                                ></v-radio>
                                </v-radio-group>
                        </v-col>
                   </v-row>
               </v-container>
             </v-card-text>
             <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="newExercise.value = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                <v-btn :loading="saving" @click="addExercise" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
            </v-card-actions>
        </v-card>
    </template>
</v-dialog>
    
</template>

<script>
export default {
    props:{
        
    },
    data(){
        return {
            exercise: {
                name: '',
                description: '',
                type: "1"
            },
            saving:false,
            responseErrors: {}
        }
    },
    methods:{

        addExercise(){
            axios.post('/backoffice/workouts/addExercise', this.exercise)
            .then(response => {

              
                if(response.data.status == "OK"){

                }
            });
        }
    }
}
</script>